import React, { useState, createContext } from 'react';
import { Cart, CollectionsInCart } from '../domain';

interface CartContextProps {
  cart?: Cart;
  collectionsInCart?: CollectionsInCart;
  setCart: (cart: Cart) => void;
  setCollectionsInCart: (collectionsInCart: CollectionsInCart) => void;
}

const CartContext = createContext<CartContextProps>({
  cart: undefined,
  collectionsInCart: undefined,
  setCart: () => void 0,
  setCollectionsInCart: () => void 0,
});

export function CartContextProvider({ children }) {
  const [cart, setCart] = useState<Cart>();
  const [collectionsInCart, setCollectionsInCart] = useState<
    CollectionsInCart
  >();

  return (
    <CartContext.Provider
      value={{ cart, collectionsInCart, setCart, setCollectionsInCart }}
    >
      {children}
    </CartContext.Provider>
  );
}

export default CartContext;
